import { render, staticRenderFns } from "./keshi_s.vue?vue&type=template&id=bcb08c08&"
import script from "./keshi_s.vue?vue&type=script&lang=js&"
export * from "./keshi_s.vue?vue&type=script&lang=js&"
import style0 from "./keshi_s.vue?vue&type=style&index=0&id=bcb08c08&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports